import { render, staticRenderFns } from "./validationHint-editor.vue?vue&type=template&id=5837f7a6&scoped=true"
import script from "./validationHint-editor.vue?vue&type=script&lang=js"
export * from "./validationHint-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5837f7a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5837f7a6')) {
      api.createRecord('5837f7a6', component.options)
    } else {
      api.reload('5837f7a6', component.options)
    }
    module.hot.accept("./validationHint-editor.vue?vue&type=template&id=5837f7a6&scoped=true", function () {
      api.rerender('5837f7a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/validationHint-editor.vue"
export default component.exports